/**
 * 自定义短信营销-短信模块
 */
import Form from './Form';
 import utils from '@/common/utils';
 import CONSTANTS from '@/utils/constant';

 export default {
   data: () => ({
    smsContent: '', // 短信签名
    filterAlreadySend:'',
    filterMaxMemberCount:'',
    filterOrderCount:'',
    filterLastOrderTime: '', // 是否过滤最近一次下单时间（同上）
    filterCrowdId: '', // 是否过滤人群id（同上）
    filterCrowdName: '',
   }),

   validators: {
     smsContent: (val,linkList) => new Promise((resolve, reject) => {
       try {
         if (!val.smsContent) {
           reject(new Error('短信内容不能为空'));
         } else if(val.smsContent.length + val.smsSign.length + CONSTANTS.LZ_SMS_CANCEL_WORD.length + 3 > 329) {
           reject(new Error('短信内容过长，请重新编辑文案'));
         }
        //  else if(val.smsContent.indexOf(`3.cn`) !== -1 && !linkList.long) {
        //    reject(new Error('请填入由系统自带短链接工具生成的短链，内容中其他渠道生成的短链接会造成发送失败。'));
        //  }else if (val.smsContent.indexOf(`3.cn`) !== -1 && val.smsContent.indexOf(` ${linkList.short} `) === -1) {
        //    reject(new Error('短链接前后请添加空格！'));
        //  }
         else {
           resolve();
         }
       } catch (error) {
         throw error;
       }
     }),
     filterAlreadySend: (val) => new Promise((resolve,reject)=>{
      try{
        if(val.filterAlreadySend===undefined){
          reject(new Error('请填写屏蔽短信营销人群天数'));
        }else {
          resolve();
        }
      } catch(e){
        throw(e)
      }
    }),
    filterMaxMemberCount: (val) => new Promise((resolve,reject)=>{
      try{
        if(val.filterMaxMemberCount===undefined){
          reject(new Error('请填写发送上限条数'));
        }else {
          resolve();
        }
      } catch(e){
        throw(e)
      }
    }),
    filterOrderCount: (val) => new Promise((resolve,reject)=>{
      try{
        if(val.filterOrderCount===undefined){
          reject(new Error('请填写屏蔽历史订单数'));
        }else {
          resolve();
        }
      } catch(e){
        throw(e)
      }
    }),
    filterLastOrderTime: (val) => new Promise((resolve, reject) => {
      try {
        if(val.filterLastOrderTimeTip && !val.filterLastOrderTime){
          reject(new Error('请录入营销人群屏蔽最近下单时间'));
        } else if (val.filterLastOrderTimeTip && val.filterLastOrderTime < 1 ||val.filterLastOrderTimeTip && val.filterLastOrderTime > 1000) {
          reject(new Error('请正确录入营销人群屏蔽最近下单时间'));
        } else {
          resolve();
        }
      } catch (error) {
        throw error;
      }
    }),
    filterCrowdId: (val) => new Promise((resolve, reject) => {
      try {
        if(val.filterCrowdTip && !val.filterCrowdId){
          reject(new Error('请选择需要屏蔽的人群包'));
        } else {
          resolve();
        }
      } catch (error) {
        throw error;
      }
    }),
   },
   components: {
     Form: Form
   }
 }
